export default "__VITE_ASSET___E3oYZi8__"